import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { FamilyMemberHistoryRowData } from "./family-history-rows";
import { createEhrWriteBackColumn } from "../../ehr/create-ehr-column";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";

export type FamilyHistoryTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function FamilyHistoryTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Family Member History",
  isRowViewed,
}: FamilyHistoryTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  const ehrContext = useEhrContext();

  const columns = useMemo(() => {
    const cols: ColumnDef<FamilyMemberHistoryRowData>[] = [
      { key: "familyMember", header: "Family Member" },
      { key: "sex", header: "Sex", hideOnSmallScreen: true },
      { key: "conditions", header: "Conditions" },
      { key: "deceased", header: "Deceased" },
    ];

    const ehrColumn = createEhrWriteBackColumn<FamilyMemberHistoryRowData>(
      ehrContext,
      "family-history"
    );
    if (ehrColumn) cols.push(ehrColumn);

    return cols;
  }, [ehrContext]);

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as FamilyMemberHistoryRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
